/* ChazaCo — cart helpers */

/* Actualiza la barra de envio gratis cuando el carrito cambia.
   Dawn dispara 'cart:refresh' con { detail: { cart } } via pubsub. */
/* Skeleton: retira .chz-img-loading cuando la imagen carga */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.chz-img-loading').forEach(function (wrap) {
    var img = wrap.querySelector('img');
    if (!img) { wrap.classList.remove('chz-img-loading'); return; }
    function reveal() {
      wrap.classList.remove('chz-img-loading');
      img.style.opacity = '1';
    }
    if (img.complete) { reveal(); }
    else { img.addEventListener('load', reveal, { once: true }); }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  function updateShipBar(totalPrice) {
    var bar = document.getElementById('chz-ship-bar');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 5000;
    var pct = Math.min(100, Math.round(totalPrice * 100 / threshold));
    var fill = document.getElementById('chz-ship-bar-fill');
    var msg  = document.getElementById('chz-ship-bar-msg');
    if (fill) fill.style.transform = 'scaleX(' + pct / 100 + ')';
    if (msg) {
      var remaining = threshold - totalPrice;
      if (remaining > 0) {
        var formatted;
        try {
          formatted = new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency: bar.dataset.currency || 'USD',
          }).format(remaining / 100);
        } catch (e) {
          formatted = (remaining / 100).toFixed(2);
        }
        var tpl = bar.dataset.tplAddMore || '';
        msg.innerHTML = tpl.replace('__AMOUNT__', formatted);
      } else {
        msg.innerHTML = bar.dataset.tplFreeShipping || '';
        if (fill) fill.style.background = 'var(--success, #1B874B)';
      }
    }
  }

  /* Dawn publica el carrito actualizado via este evento */
  document.addEventListener('cart:refresh', function (e) {
    var total = e.detail && e.detail.cart && e.detail.cart.total_price;
    if (total !== undefined) updateShipBar(total);
  });
});

/* Delegado: cualquier boton [data-chz-add-to-cart] agrega su variante al carrito.
   Vive dentro de <a class="chz-product-card">, por eso se detiene la propagacion
   para no disparar la navegacion del card. */
document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-chz-add-to-cart]');
  if (!btn) return;

  event.preventDefault();
  event.stopPropagation();

  var variantId = btn.dataset.variantId;
  var labelDefault = btn.dataset.labelDefault;
  var labelAdding  = btn.dataset.labelAdding;
  var labelAdded   = btn.dataset.labelAdded;
  var labelError   = btn.dataset.labelError;

  btn.disabled = true;
  btn.textContent = labelAdding;

  /* Pide la seccion cart-icon-bubble en la misma respuesta (igual que
     product-form.js) para que el contador del carrito en el header se
     actualice sin recargar la pagina. */
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname,
    }),
  })
    .then(function (r) { return r.json(); })
    .then(function (response) {
      if (response.status) throw new Error(response.description || response.message || 'Cart error');

      btn.textContent = labelAdded;
      btn.style.background = 'var(--success)';

      var bubbleHtml = response.sections && response.sections['cart-icon-bubble'];
      var bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleHtml && bubbleEl) {
        var parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
        if (parsedBubble) bubbleEl.innerHTML = parsedBubble.innerHTML;
      }

      /* /cart/add.js solo devuelve la linea agregada, no el total del
         carrito: se pide /cart.js para que la barra de envio gratis
         reciba el total_price real. */
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        });
    })
    .then(function () {
      setTimeout(function () {
        btn.textContent = labelDefault;
        btn.style.background = '';
        btn.disabled = false;
      }, 1800);
    })
    .catch(function () {
      btn.textContent = labelError;
      btn.disabled = false;
    });
});
